import { defineStore } from 'pinia'

/**
 * Unread state per chat provider, for the shell's Messages dot (KOVA-796 scope 4; PRD 3.3).
 *
 * KOVA-798 owns reading it from the providers (the clinical thread's read marker, Intercom's unread
 * count) and writes it here through `setClinical` / `setSupport`. The shell only renders `messages`:
 * one dot whenever either channel has something unread — never a count, never a second poller.
 * In-memory only: a new session starts clean and the providers re-report.
 */
export const useUnreadStore = defineStore('unread', {
	state: () => ({
		clinical: false,
		support: false,
	}),
	getters: {
		messages: (s) => s.clinical || s.support,
	},
	actions: {
		setClinical(unread: boolean) {
			this.clinical = unread
		},
		setSupport(unread: boolean) {
			this.support = unread
		},
	},
})
